/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_CitiesInputs */

const en_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Cities`)
};

const es_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las ciudades`)
};

const fr_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les villes`)
};

const de_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Städte`)
};

const ja_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての都市`)
};

const zh_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有城市`)
};

const ar_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع المدن`)
};

const id_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Kota`)
};

const it_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le Città`)
};

const ru_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все города`)
};

const pt_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as Cidades`)
};

const ko_all_cities = /** @type {(inputs: All_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 도시`)
};

/**
* | output |
* | --- |
* | "All Cities" |
*
* @param {All_CitiesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const all_cities = /** @type {((inputs?: All_CitiesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_CitiesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_cities(inputs)
	if (locale === "es") return es_all_cities(inputs)
	if (locale === "fr") return fr_all_cities(inputs)
	if (locale === "de") return de_all_cities(inputs)
	if (locale === "ja") return ja_all_cities(inputs)
	if (locale === "zh") return zh_all_cities(inputs)
	if (locale === "ar") return ar_all_cities(inputs)
	if (locale === "id") return id_all_cities(inputs)
	if (locale === "it") return it_all_cities(inputs)
	if (locale === "ru") return ru_all_cities(inputs)
	if (locale === "pt") return pt_all_cities(inputs)
	return ko_all_cities(inputs)
});